import { createSelector } from 'reselect'

const getTour = state => state.get('tour')

export const getTourRun = createSelector(getTour, tour => tour.get('run'))

export const getTourSteps = createSelector(getTour, tour => tour.get('steps'))

export const getTourStepIndex = createSelector(getTour, tour => tour.get('stepIndex'))
